

const IndexBatchFilesItemSchema = {
  date: { format: 'date' },
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default IndexBatchFilesItemSchema
